import { useEffect, useState } from 'react';
import { FileSearch } from 'lucide-react';
import ListaEstandar from '../ui/ListaEstandar';
import EstadoVacio from '../ui/EstadoVacio';
import TiempoRelativo from '../ui/TiempoRelativo';
import { apiPanel } from './api';

// Qué se ha hecho desde el panel. Se lee AQUÍ y no por SSH a propósito: un
// registro que solo puede consultarse entrando al servidor no lo mira nunca
// nadie, y una bitácora que nadie mira no disuade de nada.
//
// La tabla es inmutable a nivel de motor: ni el propio panel puede editarla
// ni borrarla, igual que el libro mayor de los clientes.
const ACCIONES = {
  PANEL_LOGIN: 'Inicio de sesión',
  PANEL_LOGIN_FALLIDO: 'Intento fallido',
  CLIENTE_ESTADO: 'Cambio de estado',
  CLIENTE_ESTADO_MOTIVO: 'Motivo del cambio de estado',
  CLIENTE_PLAN: 'Cambio de plan',
  CLIENTE_PLAN_MOTIVO: 'Motivo del cambio de plan',
  ADMIN_PLATAFORMA_CREADO: 'Alta de administrador',
};

export default function AuditoriaPanel() {
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiPanel
      .get('/auditoria')
      .then(setFilas)
      .catch((e) => setError(e.message))
      .finally(() => setCargando(false));
  }, []);

  if (error) return <p className="text-sm text-red-700">{error}</p>;

  const columnas = [
    {
      etiqueta: 'Cuándo',
      valor: (e) => e.fecha,
      render: (e) => <TiempoRelativo valor={e.fecha} />,
    },
    { etiqueta: 'Quién', valor: (e) => e.admin || '—' },
    {
      etiqueta: 'Qué',
      valor: (e) => ACCIONES[e.accion] || e.accion,
      render: (e) => (
        <span className={e.accion === 'PANEL_LOGIN_FALLIDO' ? 'text-red-700 font-semibold' : ''}>
          {ACCIONES[e.accion] || e.accion}
        </span>
      ),
    },
    { etiqueta: 'Cliente', valor: (e) => e.cliente || '—' },
    {
      etiqueta: 'Detalle',
      valor: (e) => detalle(e),
      clase: 'text-gray-600',
    },
  ];

  return (
    <ListaEstandar
      titulo="Bitácora del panel"
      subtitulo="Cada acción sobre un cliente, con su motivo. La tabla no se puede editar ni borrar, tampoco desde aquí."
      columnas={columnas}
      filas={filas}
      cargando={cargando}
      exportar={{ nombre: 'bitacora-panel' }}
      vacio={
        <EstadoVacio
          icono={FileSearch}
          titulo="Todavía no hay movimientos"
          descripcion="Aquí aparecerá cada acceso y cada cambio que se haga sobre un cliente."
        />
      }
    />
  );
}

// El antes/después viene como JSON con forma distinta según la acción. Se
// arma un texto legible y, ante cualquier forma inesperada, se cae a un
// guion en vez de reventar la pantalla — el mismo criterio que `estados.js`.
function detalle(e) {
  const d = e.datos_despues || {};
  const a = e.datos_antes || {};
  if (d.motivo) return d.motivo;
  if (a.estado && d.estado) return `${a.estado} → ${d.estado}`;
  if (a.plan && d.plan) return `${a.plan} → ${d.plan}`;
  if (e.accion === 'PANEL_LOGIN_FALLIDO') {
    if (d.password_ok === false) return 'Contraseña incorrecta';
    if (d.codigo_ok === false) return 'Segundo factor incorrecto';
  }
  return '—';
}
